import React, { useContext } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { mediaQueries } from "@src/styles/theme";
import { Location } from "@reach/router";
import { Flex } from "../Boxes";
import { setLanguageCookie } from "@src/utils/cookies";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import CommonModal, { CommonModalProps } from "./CommonModal";
import { localesList } from "@src/utils/localesList";
import { useTranslation as useI18nextTranslations } from "react-i18next";
import { pathnameWithoutLanguage } from "@src/utils/routes";

const modalStyle = css`
  ${mediaQueries[1]} {
    max-width: 900px;
  }
`;

type LanguageButtonProps = {
  active: boolean;
  key: string;
};
const LanguageButton = styled.button<LanguageButtonProps>`
  ${({ active }) => {
    if (active) {
      return css`
        color: white;
        background-color: #00aeef;
        border: 1px solid #00aeef;
      `;
    }
    return css`
      cursor: pointer;
      border: 1px solid #f5f5f5;
      background-color: transparent;
      color: #adadad;

      &:hover {
        background-color: #f5f5f5;
        color: black;
      }
    `;
  }}
  padding: 0;
  text-align: center;
  display: block;
  padding: 10px;
  text-decoration: none;
  font-weight: 600;
  width: 50%;
  ${mediaQueries[1]} {
    width: 25%;
  }
`;

const LanguageButtonContaniner = styled(Flex)`
  width: 100%;
`;
LanguageButtonContaniner.defaultProps = { flexWrap: "wrap" };

function getPreparedLanguage(language: string) {
  if (language.toLowerCase() === "en-us" || language.toLowerCase() === "en") {
    return "";
  }
  return `/${language.toLowerCase()}`;
}

function getFinalPath(preparedLanguage: string, path: string) {
  const finalpath = preparedLanguage.toLowerCase() + path;
  if (finalpath.endsWith("//")) {
    return finalpath.substr(0, finalpath.length - 1);
  }

  return finalpath;
}

const LanguageChooserModal = (props: CommonModalProps) => {
  const t = useContext(TranslationContext);
  const i18next = useI18nextTranslations("website2.website");

  function selectLanguage(
    language: string,
    currentLanguage: string,
    location: { location: { pathname: string; search: string } },
  ) {
    const preparedLanguage = getPreparedLanguage(language);
    const path = "/" + pathnameWithoutLanguage();
    const finalpath = getFinalPath(preparedLanguage, path);
    const search = location.location.search || "";

    setLanguageCookie(language);
    i18next.i18n.changeLanguage(language);

    window.location.href = `${finalpath}${search}`;
  }

  return (
    <CommonModal headerText={t.translate("components.signup_modal.title")} modalDialogStyle={modalStyle} {...props}>
      <Location>
        {(locationProps) => (
          <LanguageButtonContaniner>
            <TranslationContext.Consumer>
              {(value: any) =>
                value.allLanguages.map((language: string) => (
                  <LanguageButton
                    key={language}
                    active={language === value.translateLocale()}
                    onClick={() => selectLanguage(language, value.translateLocale(), locationProps)}
                  >
                    {localesList[language]}
                  </LanguageButton>
                ))
              }
            </TranslationContext.Consumer>
          </LanguageButtonContaniner>
        )}
      </Location>
    </CommonModal>
  );
};

export default LanguageChooserModal;
